/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Provision_HintInputs */

const cs_deals_provision_hint = /** @type {(inputs: Deals_Provision_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nechte prázdné pro výchozí % kanceláře. Částka má přednost před procenty.`)
};

const en_deals_provision_hint = /** @type {(inputs: Deals_Provision_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave blank to use office default %. Amount wins over percent when both are set.`)
};

/**
* | output |
* | --- |
* | "Leave blank to use office default %. Amount wins over percent when both are set." |
*
* @param {Deals_Provision_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_provision_hint = /** @type {((inputs?: Deals_Provision_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Provision_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_provision_hint(inputs)
	return cs_deals_provision_hint(inputs)
});